<template>
    <div :class="$style.buttons">
        <template v-if="isMounted && !appStore.isAppEnv">
            <Button
                v-if="appStore.platform === 'android' || appStore.platform === 'ios'"
                :leftIcon="appStore.platform === 'ios' ? 'apple' : 'android-store'"
                color="white"
                :interfaceTarget="`download-${appStore.platform}-app`"
                :label="$tr('gameDetails.androidButton')"
                @click="goToApp"
            />
            <Button
                v-else
                :class="$style.pwa_button_override"
                leftIcon="desktop"
                interfaceTarget="add-pwa"
                :label="$tr('gameDetails.installDesktop')"
                @click="onInstallPWAorMSN"
            />
        </template>
        <Button
            v-if="isMounted"
            color="carbon-400"
            interfaceTarget="report"
            leftIcon="hand"
            :label="$tr('gameContainer.report')"
            @click="layoutStore.setIsReportBugModalOpen(true)"
        />
    </div>
</template>
<script lang="ts" setup>
import { useMounted } from '@vueuse/core'

import Button from '@/components/Buttons/Button.vue'
import { CREATIVE_IDS, useGoToApp } from '@/composables/use-go-to-app'
import { useAppStore } from '@/store/app-store'
import { useLayoutStore } from '@/store/layout-store'
import { usePWAInstallStore } from '@/store/pwa-install/store'

const layoutStore = useLayoutStore()

const isMounted = useMounted()

const appStore = useAppStore()

const { goToApp } = useGoToApp(CREATIVE_IDS.GAME_DESCRIPTION)
const { onInstallPWAorMSN } = usePWAInstallStore()
</script>
<style module>
.buttons {
    display: flex;
    height: 40px;
    gap: 8px;
    margin-bottom: 8px;
}

/* Hide install button on Firefox as it doesn't support PWA installation */
@supports (-moz-appearance: none) {
    .pwa_button_override {
        display: none;
    }
}
</style>
